import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopesRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.8 4.077h8.8c.22 0 .4.18.4.4 0 .067-.03.13-.085.172l-4.1 3.19c-.36.28-.867.28-1.227 0L4.485 4.65a.22.22 0 0 1-.085-.172c0-.22.18-.4.4-.4M14 6.104v3.973c0 .22-.18.4-.4.4H4.8c-.22 0-.4-.18-.4-.4V6.104l3.45 2.683a2.2 2.2 0 0 0 2.703 0zM3.2 4.477v5.6c0 .883.718 1.6 1.6 1.6h8.8a1.6 1.6 0 0 0 1.6-1.6v-5.6a1.6 1.6 0 0 0-1.6-1.6H4.8c-.882 0-1.6.717-1.6 1.6m-1.8.8c-.332 0-.6.267-.6.6v6.6c0 .883.718 1.6 1.6 1.6h9.8a.6.6 0 1 0 0-1.2H2.4c-.22 0-.4-.18-.4-.4v-6.6c0-.333-.267-.6-.6-.6" })
});
export default SvgEnvelopesRegularIcon;
